<template>
  <FormFieldwrap>
    <textarea
      :class="[$style.base, classes]"
      :placeholder="placeholder"
      :value="value"
      v-bind="$attrs"
      @input="onChange(($event.target as HTMLInputElement).value)"
    />
  </FormFieldwrap>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate'
import { StringSchema } from 'yup'
import FormFieldwrap from '~/base/components/form/FormFieldwrap.vue'

const props = defineProps({
  id: { type: String, default: '' },
  classes: { type: String, default: '' },
  modelValue: { type: String, required: true },
  placeholder: { type: String, default: '' },
  name: { type: String, required: true },
  rules: { type: StringSchema, required: false, default: null }
})
const { value, handleChange } = useField(props.name, props.rules, {
  initialValue: props.modelValue
})
const emits = defineEmits(['update:modelValue'])
const onChange = (inputVal: string) => {
  handleChange(inputVal, true)
  emits('update:modelValue', inputVal)
}
</script>

<style module>
.base {
  border: 1px solid var(--color-grey3);
  border-radius: var(--radius-default);
  display: block;
  width: 100%;
  min-height: 105px;
  font-size: clamp(16px, 2vw, 18px);
  line-height: clamp(20px, 2vw, 22px);
  background-color: var(--color-grey2);
  transition: var(--transition-default);
  padding: 18px 12px 7px 12px;

  &:focus {
    border-color: var(--color-pacificblue);
    background-color: var(--color-white);
    outline: 0;
  }

  &.e-input--invalid,
  &.e-input--invalid:focus {
    border-color: var(--color-alert);
    color: var(--color-alert);
  }
}

.base::placeholder {
  color: var(--color-grey3);
  opacity: 1;
}
</style>
